export const LoadingIcon = {
  width: 40,
  height: 40,
};

export const Input = {
  extraSmall: 24,
  small: 32,
  medium: 40,
  large: 48,
};
